import request from '@/utils/request'
//上传视频签名
export function signatureinfo(data) {
    return request({
        url: `/MemberPost/GetSignature`,
        method: 'post',
        data
    })
}

//上传图片
export function uploadImg(data) {
    return request({
        headers: { "Content-Type": "multipart/form-data" },
        url: `/File/UploadImg`,
        method: 'post',
        data
    })
}
//发布图文
export function createPostPict(data) {
    return request({
        url: `/MemberPost/CreatePostPict`,
        method: 'post',
        data
    })
}

//创建话题
export function createPostTopic(data) {
    return request({
        url: `/MemberPost/CreatePostTopic`,
        method: 'post',
        data
    })
}

//发布视频
export function createPostVod(data) {
    return request({
        url: `/MemberPost/CreatePostVod`,
        method: 'post',
        data
    })
}

//上传图片
export function uploadImgByBase64(data) {
    return request({
        url: `/File/UploadImgByBase64`,
        method: 'post',
        data
    })
}